import SharedFileUploaderModal from "Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./useFileUploaderModal";
import { useCertificates } from "../../../../useCertificates";

function FileUploaderModal({ locationId }) {
  const { display, closeModal } = useFileUploaderModal();

  const uploadPath = `${process.env.REACT_APP_API}/api/file/uploadcertificate`;

  const extraFields = {};
  if (locationId && locationId.length == 24) extraFields.locationId = locationId;

  return (
    <SharedFileUploaderModal
      display={display}
      onClose={closeModal}
      uploadPath={uploadPath}
      extraFields={extraFields}
      title="Upload Certificate Files"
      subtitle="Select certificate files to upload"
      onUploaded={(data) => useCertificates.getState().attachFiles(data)}
    />
  );
}

export default FileUploaderModal;
